import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ColumnSettings } from '@rivethealth/data/saved-view';
import { API_URL } from './common';

@Injectable({ providedIn: 'root' })
export class ColumnPreferenceService {
  constructor(
    @Inject(API_URL) private readonly apiUrl: string,
    private readonly http: HttpClient,
  ) {}

  get(tableKey: string) {
    return this.http.get<ColumnSettings[]>(`${this.apiUrl}/column-preference`, {
      params: {
        tableKey,
      },
    });
  }

  set(tableKey: string, config: ColumnSettings[]) {
    return this.http.put<void>(`${this.apiUrl}/column-preference`, config, {
      params: {
        tableKey,
      },
    });
  }
}
